import { useExampleBrands } from 'hooks/queries/useExampleBrands'
import { ExampleBrand } from 'types'
import Styles from './ExampleBrands.module.scss'
import { Chip } from 'components/Chip/Chip'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface ExampleBrandsProps {
  onExampleBrandSelect: (exampleBrand: ExampleBrand) => void
}

const logos: Record<string, string> = {
  Nike: 'https://res.cloudinary.com/almanac/image/upload/v1739900233/onboarding_assets/nike_q2sl3g.png',
  Rains: 'https://res.cloudinary.com/almanac/image/upload/v1739900229/onboarding_assets/rains_em1adt.png',
  Pacha: 'https://res.cloudinary.com/almanac/image/upload/v1739900237/onboarding_assets/pacha_fe6las.png',
}

export const ExampleBrands = ({ onExampleBrandSelect }: ExampleBrandsProps) => {
  const { isMobile } = useResponsiveDesign()
  const { data } = useExampleBrands()
  if (!data) return null
  return (
    <div className={Styles.exampleBrands}>
      {data.example_brands
        .filter((exampleBrand) => exampleBrand.name in logos)
        .map((exampleBrand) => (
          <Chip
            variant="flat"
            key={exampleBrand.id}
            onPress={() => onExampleBrandSelect(exampleBrand)}
            selectable={false}
            size={isMobile ? 'md' : 'lg'}
          >
            <div className={Styles.chip}>
              <img src={logos[exampleBrand.name]} alt={exampleBrand.name} className={Styles.brandLogo} />
              {exampleBrand.name}
            </div>
          </Chip>
        ))}
    </div>
  )
}
